/* ==========================================================================
   BodenWerk – Quadratmeter-Rechner (variantengenau)
   Der Kunde denkt in m², Shopify verkauft Pakete. Dieses Element übersetzt
   m² -> Pakete, hält die Shopify-Quantity (= Anzahl Pakete) und die
   Line-Item-Properties korrekt und reagiert auf Variantenwechsel
   (Preis, Paketinhalt, m²-Preis, Verfügbarkeit). Add-to-Cart bleibt ein
   nativer Submit.

   Datenquelle: <script type="application/json" data-bw-variants> mit je Variante
     { id, price (Cent), available, option, packageArea (m²/Paket), pricePerM2,
       weightG (Gramm/Paket) }
   packageArea/pricePerM2 sind variant-level mit Produkt-Fallback (siehe Liquid).
   ========================================================================== */
(function () {
  var de = function (min, max) {
    return new Intl.NumberFormat('de-DE', { minimumFractionDigits: min, maximumFractionDigits: max });
  };
  var fmtArea = de(2, 2); // 26,14
  var fmtAreaIn = de(0, 2); // 23 / 23,5
  var fmtPack = de(0, 3); // 2,376
  var fmtMoney = de(2, 2); // 415,58

  function money(v) {
    return fmtMoney.format(v) + ' €';
  }
  function plural(n, one, many) {
    return n === 1 ? one : many;
  }

  if (customElements.get('bw-boden-rechner')) return;

  customElements.define(
    'bw-boden-rechner',
    class BwBodenRechner extends HTMLElement {
      connectedCallback() {
        // Variantendaten
        try {
          this.variants = JSON.parse(this.querySelector('[data-bw-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }

        // DOM
        this.idInput = this.querySelector('[data-bw-id]');
        this.areaInput = this.querySelector('[data-bw-area]');
        this.qtyInput = this.querySelector('[data-bw-qty]');
        this.wasteInputs = Array.prototype.slice.call(this.querySelectorAll('input[name="bw-waste"]'));
        this.variantInputs = Array.prototype.slice.call(this.querySelectorAll('input[name="bw-variant"]'));
        this.minusBtn = this.querySelector('[data-bw-minus]');
        this.plusBtn = this.querySelector('[data-bw-plus]');
        this.submitBtn = this.querySelector('[type="submit"]');
        this.grossmengeBox = this.querySelector('[data-bw-grossmenge]');
        this.angebotLink = this.querySelector('[data-bw-angebot]');
        this.versandEl = this.querySelector('[data-bw-versand]');
        this.maxGewichtG = 0;
        try {
          var vd = document.querySelector('[data-bw-versand-daten]');
          this.maxGewichtG = vd ? JSON.parse(vd.textContent).maxGewichtG || 0 : 0;
        } catch (e) {
          this.maxGewichtG = 0;
        }
        this.grossmenge = false;
        // Enter im Flaechenfeld wuerde das Formular trotz verstecktem
        // Kaufknopf abschicken. Bei Grossmenge stattdessen zur Anfrage.
        var formular = this.closest('form');
        if (formular) {
          formular.addEventListener('submit', function (e) {
            if (!this.grossmenge) return;
            e.preventDefault();
            if (this.angebotLink) window.location.href = this.angebotLink.href;
          }.bind(this));
        }
        this.wasteHint = this.querySelector('[data-bw-wastehint]');
        this.reco = this.querySelector('[data-bw-reco]');
        this.recoMain = this.querySelector('[data-bw-reco-main]');
        this.recoSub = this.querySelector('[data-bw-reco-sub]');
        this.areaError = this.querySelector('[data-bw-areaerror]');
        this.deliveredEl = this.querySelector('[data-bw-delivered]');
        this.packUnitEl = this.querySelector('[data-bw-packunit]');
        this.priceM2El = this.querySelector('[data-bw-price-m2]');
        this.pricePackEl = this.querySelector('[data-bw-price-pack]');
        this.priceTotalEl = this.querySelector('[data-bw-price-total]');
        this.propPack = this.querySelector('[data-bw-prop="pack"]');
        this.propDesired = this.querySelector('[data-bw-prop="desired"]');
        this.propWaste = this.querySelector('[data-bw-prop="waste"]');
        this.propDelivered = this.querySelector('[data-bw-prop="delivered"]');

        // Mobile Kaufleiste
        this.leiste = this.querySelector('[data-bw-kaufleiste]');
        this.leisteBetrag = this.querySelector('[data-bw-kaufleiste-betrag]');
        this.leisteZusatz = this.querySelector('[data-bw-kaufleiste-zusatz]');
        this.leisteBtn = this.querySelector('[data-bw-kaufleiste-btn]');

        // Zustand
        this.packages = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
        this.desiredArea = 0; // 0 = keine gültige Flächeneingabe
        this.areaInvalid = false;
        // Versandzeile erst zeigen, wenn eine Menge feststeht (Flaeche oder
        // Paketzahl). Vorher stuende 180 € Fracht gegen ein einzelnes Paket.
        this.mengeGewaehlt = false;

        // Events
        this.areaInput.addEventListener('input', this.onArea.bind(this));
        this.wasteInputs.forEach(
          function (w) {
            w.addEventListener('change', this.onArea.bind(this));
          }.bind(this)
        );
        this.initKaufleiste();
        this.qtyInput.addEventListener('input', this.onPackages.bind(this));
        this.qtyInput.addEventListener('blur', this.onPackages.bind(this));
        this.minusBtn.addEventListener('click', this.step.bind(this, -1));
        this.plusBtn.addEventListener('click', this.step.bind(this, 1));
        this.variantInputs.forEach(
          function (r) {
            r.addEventListener(
              'change',
              function (e) {
                this.selectVariant(e.target.value);
              }.bind(this)
            );
          }.bind(this)
        );

        // Startvariante = Wert des versteckten id-Felds
        this.selectVariant(this.idInput ? this.idInput.value : null, true);
      }

      // --- Varianten -------------------------------------------------------
      selectVariant(id, initial) {
        var v =
          this.variants.filter(function (x) {
            return String(x.id) === String(id);
          })[0] ||
          this.variants[0] ||
          null;
        this.current = v;

        // Kein Paketinhalt gepflegt -> nicht raten: Kauf für diese Variante sperren,
        // falsche Liefermengen sind teurer als ein deaktivierter Button.
        var area = v && v.packageArea > 0 ? v.packageArea : 0;
        this.dataMissing = area <= 0;
        if (this.dataMissing && !this._warned) {
          console.warn('[bw-boden-rechner] package_area fehlt für Variante ' + (v && v.id) + ' – bitte in Shopify pflegen.');
          this._warned = true;
        }
        this.packageArea = area;
        this.packagePrice = v ? (v.price || 0) / 100 : 0; // Variantenpreis = Paketpreis
        this.packagePriceCent = v ? v.price || 0 : 0;
        this.packageWeightG = v ? v.weightG || 0 : 0;
        this.pricePerM2 =
          v && v.pricePerM2 > 0
            ? v.pricePerM2
            : this.packagePrice > 0 && this.packageArea > 0
            ? this.packagePrice / this.packageArea
            : 0;

        if (this.idInput && v) this.idInput.value = v.id;
        this.updateAvailability();

        if (initial) {
          this.render();
        } else {
          // Variantenwechsel: bei gültiger Flächeneingabe Pakete neu rechnen, sonst Menge behalten.
          this.recompute();
        }
      }

      updateAvailability() {
        if (!this.submitBtn) return;
        var soldOut = this.current && this.current.available === false;
        this.submitBtn.disabled = !!soldOut || this.dataMissing || this.areaInvalid;
        this.submitBtn.textContent = soldOut
          ? 'Nicht verfügbar'
          : this.dataMissing
          ? 'Vorübergehend nicht bestellbar'
          : 'In den Warenkorb';
      }

      // --- Eingaben --------------------------------------------------------
      get waste() {
        var c = this.wasteInputs.filter(function (w) {
          return w.checked;
        })[0];
        return c ? parseFloat(c.value) : 0;
      }

      parseArea() {
        var raw = (this.areaInput.value || '').replace(',', '.').trim();
        var n = parseFloat(raw);
        return isFinite(n) && n > 0 ? n : 0;
      }

      onArea() {
        var area = this.parseArea();
        this.toggleWasteHint();
        if (area > 0 && window.bwEreignis) {
          // Frage: Nutzt ueberhaupt jemand den Rechner, und mit welchen Flaechen?
          window.bwEreignis.meldeEinmal('bw_rechner_flaeche', String(Math.round(area)), {
            flaeche_m2: Math.round(area),
            produkt: this.getAttribute('data-bw-handle') || ''
          });
        }
        if (area <= 0) {
          this.desiredArea = 0;
          this.areaInvalid = this.areaInput.value.trim() !== '';
          // Keine alte Berechnung stehen lassen: Menge zurueck auf ein Paket,
          // Kaufknopf sperrt updateAvailability, solange die Eingabe ungueltig ist.
          this.packages = 1;
          this.qtyInput.value = 1;
          this.mengeGewaehlt = false;
        } else {
          this.mengeGewaehlt = true;
          this.areaInvalid = false;
          this.desiredArea = area;
        }
        this.recompute();
      }

      // Paketzahl von Hand gewaehlt: die Flaechenberechnung gilt nicht mehr.
      // Feld leeren, damit Empfehlung und Bestelldaten nicht widersprechen.
      manuelleMenge() {
        if (this.desiredArea > 0 || this.areaInvalid) {
          this.desiredArea = 0;
          this.areaInvalid = false;
          this.areaInput.value = '';
        }
      }

      onPackages() {
        this.manuelleMenge();
        var p = parseInt(this.qtyInput.value, 10);
        if (!isFinite(p) || p < 1) p = 1;
        this.packages = p;
        this.qtyInput.value = p;
        this.mengeGewaehlt = true;
        this.render();
      }

      step(delta) {
        this.manuelleMenge();
        this.packages = Math.max(1, this.packages + delta);
        this.qtyInput.value = this.packages;
        this.mengeGewaehlt = true;
        this.render();
      }

      toggleWasteHint() {
        if (this.wasteHint) this.wasteHint.hidden = this.waste !== 0;
        // Frage: Sind 10 Prozent die richtige Voreinstellung?
        if (this.waste !== 10 && window.bwEreignis) {
          window.bwEreignis.meldeEinmal('bw_verschnitt_geaendert', String(this.waste), {
            verschnitt_prozent: this.waste,
            produkt: this.getAttribute('data-bw-handle') || ''
          });
        }
      }

      // Aus gültiger Flächeneingabe die Paketzahl ableiten, sonst Menge behalten.
      recompute() {
        if (this.desiredArea > 0 && !this.dataMissing) {
          var needed = this.desiredArea * (1 + this.waste / 100);
          // Epsilon gegen Fließkomma-Artefakte: 50 × 1,1 / 2,75 ergibt 20,0000004,
          // Math.ceil daraus fälschlich 21. -1e-9 fängt nur das Rauschen ab.
          this.packages = Math.max(1, Math.ceil(needed / this.packageArea - 1e-9));
          this.qtyInput.value = this.packages;
        }
        this.render();
      }

      // --- Mobile Kaufleiste ------------------------------------------------
      // Einblenden, sobald der echte Kaufbutton aus dem Bild ist. Ohne
      // IntersectionObserver bleibt die Leiste weg; der Kauf funktioniert
      // ueber den regulaeren Button ohnehin.
      initKaufleiste() {
        if (!this.leiste || !this.submitBtn || !window.IntersectionObserver) return;
        this.leiste.hidden = false;

        var self = this;
        this.leisteBtn.addEventListener('click', function () {
          // Frage: War die mobile Kaufleiste den Aufwand wert?
          if (window.bwEreignis) {
            window.bwEreignis.melde('bw_kaufleiste_genutzt', {
              zustand: self.mengeGewaehlt ? 'kauf' : 'sprung_zum_feld'
            });
          }
          if (self.grossmenge && self.angebotLink) {
            window.location.href = self.angebotLink.href;
          } else if (self.mengeGewaehlt) {
            self.submitBtn.click();
          } else {
            self.areaInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
            window.setTimeout(function () { self.areaInput.focus(); }, 420);
          }
        });

        // Zwei Bedingungen, damit die Leiste beim Landen nicht sofort im Weg
        // steht: der Besucher muss ein Stueck gescrollt haben UND der echte
        // Kaufbutton darf nicht im Bild sein.
        this.kaufBtnImBild = false;
        this.gescrollt = false;

        this.leisteBeobachter = new IntersectionObserver(
          function (eintraege) {
            self.kaufBtnImBild = eintraege[0].isIntersecting;
            self.leisteZustand();
          },
          { rootMargin: '0px 0px -80px 0px' }
        );
        this.leisteBeobachter.observe(this.submitBtn);

        var wartet = false;
        var aufScroll = function () {
          if (wartet) return;
          wartet = true;
          window.requestAnimationFrame(function () {
            wartet = false;
            var neu = window.scrollY > 500;
            if (neu !== self.gescrollt) {
              self.gescrollt = neu;
              self.leisteZustand();
            }
          });
        };
        window.addEventListener('scroll', aufScroll, { passive: true });
        aufScroll();
      }

      leisteZustand() {
        if (!this.leiste) return;
        this.leiste.classList.toggle('bw-kaufleiste--sichtbar', this.gescrollt && !this.kaufBtnImBild);
      }

      renderKaufleiste(delivered, total) {
        if (!this.leiste) return;
        var bereit = this.mengeGewaehlt;
        if (bereit) {
          this.leisteBetrag.textContent = money(total);
          this.leisteZusatz.textContent =
            de(0, 0).format(this.packages) + ' ' + plural(this.packages, 'Paket', 'Pakete') + ' · ' + fmtArea.format(delivered) + ' m²';
          this.leisteBtn.textContent = this.grossmenge
            ? 'Angebot anfordern'
            : this.submitBtn && this.submitBtn.disabled
            ? 'Nicht verfügbar'
            : 'In den Warenkorb';
        } else {
          this.leisteBetrag.textContent = this.pricePerM2 > 0 ? money(this.pricePerM2) : money(this.packagePrice);
          this.leisteZusatz.textContent = this.pricePerM2 > 0 ? 'pro m², Verkauf in Paketen' : 'pro Paket';
          this.leisteBtn.textContent = 'Fläche eingeben';
        }
        this.leisteBtn.disabled = bereit && this.submitBtn && !this.grossmenge ? this.submitBtn.disabled : false;
      }

      // Gleiche Grenze wie bw-cart.liquid: Warenkorb plus diese Menge ueber dem
      // Hoechstgewicht der Staffel fuehrt in die Angebotsanfrage.
      renderGrossmenge(delivered) {
        if (!this.grossmengeBox || !this.maxGewichtG || !this.packageWeightG) return;
        var basisG = this.versandEl ? parseInt(this.versandEl.getAttribute('data-basis-gramm'), 10) || 0 : 0;
        var gewichtG = basisG + this.packages * this.packageWeightG;
        var neu = gewichtG > this.maxGewichtG;
        this.grossmenge = neu;
        this.grossmengeBox.hidden = !neu;
        this.submitBtn.hidden = neu;
        if (!neu || !this.angebotLink) return;
        var params = new URLSearchParams({
          anfrage: 'grossmenge',
          produkt: this.angebotLink.getAttribute('data-bw-produkt') || '',
          variante: this.current && this.current.option ? this.current.option : '',
          pakete: String(this.packages),
          flaeche: fmtArea.format(delivered) + ' m²',
          kg: de(0, 0).format(Math.round(gewichtG / 1000))
        });
        this.angebotLink.href = this.angebotLink.href.split('?')[0] + '?' + params.toString();
      }

      // --- Ausgabe ---------------------------------------------------------
      render() {
        var delivered = this.packages * this.packageArea;
        var total = this.packages * this.packagePrice;

        if (this.desiredArea > 0) {
          this.reco.hidden = false;
          this.areaError.hidden = true;
          this.recoMain.textContent =
            de(0, 0).format(this.packages) +
            ' ' +
            plural(this.packages, 'Paket', 'Pakete') +
            ' = ' +
            fmtArea.format(delivered) +
            ' m²';
          this.recoSub.textContent =
            'Berechnet aus ' + fmtAreaIn.format(this.desiredArea) + ' m² + ' + this.waste + ' % Verschnitt';
        } else {
          this.reco.hidden = true;
          this.areaError.hidden = !this.areaInvalid;
        }

        this.packUnitEl.textContent = plural(this.packages, 'Paket', 'Pakete');
        this.deliveredEl.textContent = 'entspricht ' + fmtArea.format(delivered) + ' m²';

        this.priceM2El.textContent = this.pricePerM2 > 0 ? money(this.pricePerM2) : '—';

        // Header-Preis (€/m²) bei Variantenwechsel mitziehen
        var hdr = document.getElementById('BwHeaderPrice');
        if (hdr && this.pricePerM2 > 0) hdr.textContent = money(this.pricePerM2);
        this.pricePackEl.textContent = this.packagePrice > 0 ? money(this.packagePrice) : '—';
        this.priceTotalEl.textContent = this.packagePrice > 0 && !this.areaInvalid ? money(total) : '—';
        this.updateAvailability();

        // Line Item Properties
        if (this.propPack) this.propPack.value = fmtPack.format(this.packageArea) + ' m²';
        this.propDesired.value = this.desiredArea > 0 ? fmtAreaIn.format(this.desiredArea) + ' m²' : '';
        this.propWaste.value = this.desiredArea > 0 ? this.waste + ' %' : '';
        // Leere Felder nicht absenden, sonst stehen leere Zeilen in Warenkorb und Bestellung
        this.propDesired.disabled = !this.propDesired.value;
        this.propWaste.disabled = !this.propWaste.value;
        this.propDelivered.value = fmtArea.format(delivered) + ' m²';

        this.renderGrossmenge(delivered);
        this.renderKaufleiste(delivered, total);

        // Versandkosten und Weg zur kostenfreien Lieferung mitziehen.
        var warenwertCent = this.packages * this.packagePriceCent;
        if (this.versandEl && !this.mengeGewaehlt) {
          this.versandEl.hidden = true;
        } else if (window.bwVersand) {
          window.bwVersand.aktualisieren({
            warenwertCent: warenwertCent,
            gewichtG: this.packages * this.packageWeightG,
            paketPreisCent: this.packagePriceCent,
            paketGewichtG: this.packageWeightG
          });
        }

        // Frage: Wie oft greift der Gratisversand knapp nicht?
        if (window.bwEreignis && warenwertCent >= 170000 && warenwertCent < 200000) {
          window.bwEreignis.meldeEinmal('bw_versand_knapp_verfehlt', 'ja', {
            fehlbetrag_euro: Math.round((200000 - warenwertCent) / 100),
            pakete: this.packages
          });
        }
      }
    }
  );
})();
